module.exports = __webpack_public_path__ + "img/icon-arrow-download.d368c728.svg";